import MainLayout from '../../components/layouts/MainLayout'
import { PredictContextProvider } from './context/PredictContextProvider'
import MainAnalyzePage from './Main'

const AnalyzePage = () => {

    return (
        <MainLayout>
            {/* <PredictContextProvider> */}
            <MainAnalyzePage />
            {/* </PredictContextProvider> */}
        </MainLayout>
    )
}

export default AnalyzePage
